import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { User } from 'src/app/classes';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-select-user',
  templateUrl: './select-user.component.html',
  styleUrls: ['./select-user.component.css']
})
export class SelectUserComponent implements OnDestroy, OnInit {

  public users: User[] = [];
  public userLoadSubscription: Subscription;

  constructor(
    private _dataService: DataService,
    private _dialogRef: MatDialogRef<SelectUserComponent>
  ) {

  }

  close(){
    this._dialogRef.close(null);
  }

  ngOnDestroy(){
    if(this.userLoadSubscription) this.userLoadSubscription.unsubscribe();
    this.userLoadSubscription = null;
  }

  ngOnInit(): void {
    if(this._dataService.allUsersLoaded) this.users = this._dataService.users;
    else {
      this.userLoadSubscription = this._dataService.usersLoadedAnchor.subscribe(() => this.users = this._dataService.users);
      if(!this._dataService.allUsersLoading) this._dataService.loadUsers();
    }
  }

  userSelected(user: User){
    this._dialogRef.close(user);
  }

}
